export const USER_API_ROUTES = {
  GET_CHAPTERS: '/users/customers/chapter/:id',
  GET_CHAPTER_BY_ID: '/users/customers/chapter/:id',
};
